import { ImageSourceHelper } from '@sortlist-frontend/media';
import { isNonEmptyString } from '@sortlist-frontend/utils';
import { ImageLoaderProps } from 'next/image';

const DEFAULT_LANDSCAPE_IMAGE = '/_img/default/default-image-landscape.svg';

export const COVER_QUALITY = 90;

export const getCoverSource = (coverUrl: string | null | undefined) =>
  isNonEmptyString(coverUrl) ? coverUrl : DEFAULT_LANDSCAPE_IMAGE;

export const coverLoader = ({ src, width, quality }: ImageLoaderProps) =>
  ImageSourceHelper.fromUrl(src, { width, quality: quality ?? COVER_QUALITY });
